<div
  class="bg-gray-50 rounded-xl ca-shadow h-full overflow-y-clip overflow-x-clip"
>
  <div class="flex justify-between">
    <h2 class="pl-2 pt-2 text-base font-bold text-gray-700 m-0">{{ title }}</h2>
    @if (helpUrl) {
      <div class="pt-2 pr-2 text-gray-700">
        <a
          [title]="'help' | translate"
          [href]="helpUrl"
          target="_blank"
          class="text-gray-700 hover:text-caPrimaryAction transition-colors"
          ><mat-icon>help_outlined</mat-icon></a
        >
      </div>
    }
    <ng-content select="[slot=trailingHeader]"></ng-content>
  </div>
  <div class="overflow-y-auto h-full pb-4 p-2">
    <ng-content></ng-content>
  </div>
</div>
